/**
 * Enum representing the different types of courts in the system.
 */
export enum CourtType {
  APPEALS_COURT = 'Appeals Court',
  CIRCUIT_COURT = 'Circuit Court',
  COUNTY_COURT = 'County Court',
  DISTRICT_COURT = 'District Court',
  JUSTICE_COURT = 'Justice Court',
  MAGISTRATE_COURT = 'Magistrate Court',
  MUNICIPAL_COURT = 'Municipal Court',
  STATE_COURT = 'State Court',
  SUPERIOR_COURT = 'Superior Court'
}

/**
 * Array of all court types for use in dropdowns and filters.
 */
export const COURT_TYPES: string[] = Object.values(CourtType);
